import { render, staticRenderFns, recyclableRender, components } from "./u-form.vue?vue&type=template&id=786a592e&scoped=true&"
var renderjs
import script from "./u-form.vue?vue&type=script&lang=js&"
export * from "./u-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../HBuilderX.3.8.4.20230531/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "786a592e",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "uni_modules/uview-ui/components/u-form/u-form.vue"
export default component.exports